export default __webpack_public_path__ + "img/bf4394ea07a14d8c028c15b6d199ac08.png";